/** Indicador de carga. Lleva texto accesible para lectores de pantalla. */
export function Spinner({ label = 'Cargando' }: { readonly label?: string }) {
  return (
    <span className="qr-spinner" role="status">
      <span className="qr-spinner__ring" aria-hidden="true" />
      <span className="qr-visually-hidden">{label}</span>
    </span>
  );
}
